import { render, staticRenderFns } from "./FamilyMembersStep.vue?vue&type=template&id=3c9af73d&"
import script from "./FamilyMembersStep.vue?vue&type=script&lang=js&"
export * from "./FamilyMembersStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports